/**
 * Registers the bundled fonts on web.
 *
 * Imported for its side effect from index.web.ts. The TTFs go through webpack's
 * asset pipeline so they are SERVED FROM THIS ORIGIN — the design's prototype pulled
 * them from Google's CDN, which this app cannot do: the console is used on patchy
 * mobile data, and a webfont that fails to load silently falls back to a system face
 * and quietly undoes the typography.
 *
 * Weights are separate files rather than a variable font, matching native, where
 * fontWeight cannot select an instance from a variable TTF.
 */
import JetBrainsMonoBold from '~/assets/fonts/JetBrainsMono-Bold.ttf';
import JetBrainsMonoMedium from '~/assets/fonts/JetBrainsMono-Medium.ttf';
import JetBrainsMonoRegular from '~/assets/fonts/JetBrainsMono-Regular.ttf';
import SoraBold from '~/assets/fonts/Sora-Bold.ttf';
import SoraMedium from '~/assets/fonts/Sora-Medium.ttf';
import SoraRegular from '~/assets/fonts/Sora-Regular.ttf';
import SoraSemiBold from '~/assets/fonts/Sora-SemiBold.ttf';

// Sora ships from Google as one variable file with no Medium instance, so these four are
// instanced from it at 400/500/600/700 and committed. Static files rather than the variable
// one because React Native on Android cannot pick an instance out of a variable TTF by
// fontWeight — the same reason Instrument Sans shipped as four files before it.
const FACES: Array<[string, string, number]> = [
  ['Sora', SoraRegular, 400],
  ['Sora', SoraMedium, 500],
  ['Sora', SoraSemiBold, 600],
  ['Sora', SoraBold, 700],
  ['JetBrainsMono', JetBrainsMonoRegular, 400],
  ['JetBrainsMono', JetBrainsMonoMedium, 500],
  ['JetBrainsMono', JetBrainsMonoBold, 700],
];

const css = FACES.map(
  ([family, url, weight]) =>
    `@font-face{font-family:"${family}";src:url(${url}) format("truetype");font-weight:${weight};font-style:normal;font-display:swap}`,
).join('\n');

const style = document.createElement('style');
style.appendChild(document.createTextNode(css));
document.head.appendChild(style);
